import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";
import { MandrillEmailTemplate } from "../shared/model/mandrillEmailTemplate";
import { GenericService } from "../shared/generic.service";
import { ConfigureService } from "../configure/configure.service";
import { catchError } from "rxjs/operators";

@Injectable()
export class MandrillService {
    constructor(
        private http: HttpClient,
        private genericService: GenericService,
        private config: ConfigureService
    ) {}

    sendTemplate(mandrill: MandrillEmailTemplate): Observable<any> {
        const mandrillData = {};
        mandrillData["key"] = mandrill.key;
        mandrillData["template_name"] = mandrill.template_name;
        mandrillData["template_content"] = mandrill.template_content;
        mandrillData["message"] = mandrill.message;

        return this.http.post(
            `${this.config.params.mandrillEndpoint}/messages/send-template.json`,
            mandrillData
        );
    }
}
